import * as actionTypes from "./settingsTypes";

const INITIAL_STATE = {
    roleList: [],
    authorizationList: [],
    authorizedPages: [],
    authorizedPagesLoaded: false,
    userList: [],
    userDataList: [],
    customerList: [],
    pageRoute: "",
    serviceCallOriginList: [],
    quickCreateSetting: null,
};

const settingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_ROLE_LIST:
            return {
                ...state,
                roleList: action.payload.list,
            };
        case actionTypes.SET_AUTHORIZATION_LIST:
            return {
                ...state,
                authorizationList: action.payload.list,
            };
        case actionTypes.SET_AUTHORIZED_PAGES:
            return {
                ...state,
                authorizedPages: action.payload.list,
                authorizedPagesLoaded: true
            };
        case actionTypes.SET_USER_LIST:
            return {
                ...state,
                userList: action.payload.list,
            };
        case actionTypes.SET_USER_DATA_LIST:
            return {
                ...state,
                userDataList: action.payload.list,
            };
        case actionTypes.SET_CUSTOMER_LIST:
            return {
                ...state,
                customerList: action.payload.list,
            };
        case actionTypes.SET_PAGE_ROUTE:
            return {
                ...state,
                pageRoute: action.payload,
            };
        case actionTypes.SETEMAILCREDENTIALLIST:
            return {
                ...state,
                emailCredentialList: action.payload.list,
            };
        case actionTypes.SETEMAILCONTENTLIST:
            return {
                ...state,
                emailContentList: action.payload.list,
            };
        case actionTypes.SETSERVICECALLORIGINLIST:
            return {
                ...state,
                serviceCallOriginList: action.payload.list,
            };
        case actionTypes.SETQUICKCREATESETTING:
            return {
                ...state,
                quickCreateSetting: action.payload.list,
            };
        default:
            return state;
    };
};

export default settingsReducer;